export const ASSERT_OK = 'ASSERT_OK';
export const ASSERT_STATUS_CODE = 'ASSERT_STATUS_CODE';

export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
